import { useLingui } from '@lingui/react/macro'

import { DialogHeader } from '@/layouts/Dialog'
import { FeatureSteps, FeatureStepsProps } from '@/features/integrations'
import { useParams } from 'wouter'
import { Suspense } from '@/components/ui/Suspense'
import { GraphQL } from '@guestgoodie/graphql'

function isProvider(value: string): value is GraphQL.Providers {
  return Object.values(GraphQL.Providers).includes(value as GraphQL.Providers)
}

function isType(value: string): value is GraphQL.IntegrationTypes {
  return Object.values(GraphQL.IntegrationTypes).includes(
    value as GraphQL.IntegrationTypes
  )
}

function Integration(props: FeatureStepsProps) {
  const { t } = useLingui()

  return (
    <div className="flex flex-col p-8">
      <DialogHeader
        title={t`Integration`}
        description={t`Setup and Edit Integration`}
      />
      <FeatureSteps {...props} />
    </div>
  )
}

export default function IntegrationSuspense() {
  const params = useParams() as { provider: string; type: string }

  if (!params) return null

  const { type, provider } = params

  if (!type || !isType(type)) return null
  if (!provider || !isProvider(provider)) return null

  return (
    <Suspense isDialog>
      <Integration provider={provider} type={type} />
    </Suspense>
  )
}
